var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemReportar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "po9pmx64ga",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#po9pmx64ga)",
    transform: "translate(-137.000000, -407.000000) translate(0.000000, 385.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#463C32",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.508 1.67C14.411.276 11.892-.272 9.408.127c-.043 0-.086.005-.13.012-2.625.456-4.917 1.907-6.453 4.085C1.291 6.404.697 9.05 1.152 11.676c.075.434.18.87.314 1.294.55 1.785.414 3.699-.381 5.387-.139.293-.093.64.116.89.208.248.54.351.855.266l3.728-1.018c1.578.967 3.36 1.466 5.18 1.466.66 0 1.326-.065 1.989-.2 2.613-.526 4.865-2.037 6.34-4.256C22.34 10.923 21.09 4.718 16.508 1.67zm1.4 12.914c-1.23 1.85-3.106 3.11-5.283 3.548-2.175.438-4.393.003-6.244-1.228-.138-.091-.299-.139-.46-.139-.074 0-.148.01-.22.03l-2.538.693c.428-1.635.396-3.366-.109-5.012-.112-.358-.201-.723-.264-1.084-.379-2.189.117-4.394 1.396-6.21C5.443 3.397 7.31 2.2 9.452 1.8c.04-.002.08-.006.12-.013 2.102-.363 4.24.089 6.017 1.27 3.818 2.539 4.858 7.71 2.32 11.528z",
    transform: "translate(137.000000, 22.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.984 4.909c-.46 0-.832.371-.832.831v4.99c0 .459.372.83.832.83.46 0 .831-.372.831-.83V5.74c0-.46-.371-.831-.831-.831zM11.748 13.822c-.041-.109-.1-.2-.174-.275-.042-.033-.084-.075-.133-.1-.042-.033-.092-.057-.142-.074-.05-.026-.1-.042-.158-.05-.265-.059-.557.034-.747.224-.075.075-.133.167-.175.275-.042.1-.066.207-.066.316 0 .108.024.216.066.316s.1.19.175.274c.083.075.174.133.274.175.1.041.208.066.316.066.108 0 .215-.025.315-.066.1-.042.19-.1.275-.175.074-.083.133-.175.174-.274.042-.1.067-.208.067-.316 0-.109-.025-.217-.067-.316z",
    transform: "translate(137.000000, 22.000000)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemReportar);
export default __webpack_public_path__ + "static/media/systemReportar.217c94b4.svg";
export { ForwardRef as ReactComponent };